<!-- metallurgy -->
<template>
  <div class="metallurgy">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p1">赛迈特攀登悬浮冶金技术和产业的巅峰</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2 " id="悬浮冶金简介">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1">
                  <span>悬浮冶金</span>简介
                </div>
                <div class="p2"></div>
                <div class="p3">ABOUT LEVITATION METALLURGY</div>
                <div class="p4">
                  悬浮冶金技术全称为真空电磁悬浮熔炼技术，是指在真空熔炼过程中利用电磁场使熔池呈悬浮状态的技术。这是当代最先进的材料制备技术，用于制备国防和高科技产业急需的主要材料。
                </div>
                <div class="p5">
                  悬浮熔炼与其它材料技术相结合的技术统称为悬浮冶金技术。真空熔炼技术排除了气体分子对材料的污染，悬浮熔炼技术则在此基础上进一步消除了坩埚材料引起的污染，它排除了所有的污染来源，是当代最先进的，最理想的材料制备技术。该技术排除了坩埚材料对熔池的污染，能制备纯度特别高，成分非常均匀和精确的材料；适合于活泼金属及其合金的熔炼和处理；排除了坩埚材料对熔炼温度的限制，能在感应熔炼的条件下获得超过3000℃的熔炼温度。
                </div>
              </div>
            </div>
            <div class="box2">
              <div class="imgBox">
                <img src="../../static/images/metallurgy/悬浮.png" alt="">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3 " id="技术优势">
      <div class="s3_innerBox typeArea">
        <div class="bodyBox">
          <div class="box1">
            <div class="item" :style="section3backgroundDiv1">
              <div class="label">
                成分均匀
              </div>
            </div>
            <div class="item" :style="section3backgroundDiv2">
              <div class="label">
                高纯度
              </div>
            </div>
            <div class="item" :style="section3backgroundDiv3">
              <div class="label">
                熔炼温度高
              </div>
            </div>
          </div>
          <div class="box2">
            <div class="topTitle leftTop">
              <div class="p1">
                <span>技术</span>优势
              </div>
              <div class="p2"></div>
              <div class="p3" style="marginBottom:5px">TECHNOLOGICAL</div>
              <div class="p3">ADVANTAGE</div>
              <div class="p4">
                悬浮熔炼具有无污染，温度高，成分均匀，具有铸造功能等优点;
              </div>
              <div class="p5">
                这种技术适合于制备高纯金属，活泼金属，难熔金属，贵金属，以及成分复杂，技术要求高的合金。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4 " id="应用领域">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>应用</span>领域
          </div>
          <div class="p2"></div>
          <div class="p3">APPLICATION AREA</div>
          <div class="p4">应用于国防技术，尖端技术和现代产业中的先进技术领域</div>
        </div>
        <div class="bodyBox">
          <div class="p1">航天航空技术领域</div>
          <div class="p1">新能源技术领域</div>
          <div class="p1">信息技术领域</div>
          <div class="p1">矿产精炼领域</div>
          <div class="p1">核武器、核能技术领域</div>
          <div class="p1">兵器材料技术领域</div>
          <div class="p1">战略材料技术领域</div>
          <div class="p1">前沿新材料开发</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'metallurgy',
    components: {},
    data() {
      return {
        section3backgroundDiv1: {
          backgroundImage: 'url(' + require('../../static/images/metallurgy/成分均匀.jpg') + ')',
        },
        section3backgroundDiv2: {
          backgroundImage: 'url(' + require('../../static/images/metallurgy/高纯度.jpg') + ')',
        },
        section3backgroundDiv3: {
          backgroundImage: 'url(' + require('../../static/images/metallurgy/温度高.jpg') + ')',
        }

      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
    },
    mounted() {
      if(this.$store.state.pageId){
        this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
          behavior:'smooth',
          block: "start"
        })
      }else{
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      this.$store.commit('savePageId','')
    },
    methods: {
      init() {

      },
    },
  }

</script>

<style lang='less' scoped>
  .metallurgy {
    min-width: 1200px;

    height: 100%;


    .section1 {
      width: 100%;
      height: 600px;
      background: url('../../static/images/metallurgy/banner.jpg') no-repeat;
      background-position: center;

      .s1_innerBox {
        padding-top: 234px;
        text-align: left;

        .opctBox {
          width: 1245px;
          height: 230px;
          // opacity: 0.4;
          background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 2%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.4) 80%, rgba(255, 255, 255, 0.1) 98%, rgba(255, 255, 255, 0) 100%);

          .p1 {
            font-size: 48px;
            line-height: 48px;
            padding-top: 50px;
            color: #fefefe;
          }

          .line {
            width: 200px;
            height: 8px;
            margin-top: 85px;
            background-color: #c30000;
          }
        }

      }
    }

    .section2 {
      width: 100%;
      height: 940px;

      .s2_innerBox {
        height: 100%;
        padding-top: 268px;

        .bodyBox {
          width: 1180px;
          height: 551px;
          padding: 0 0 20px 35px;
          background-color: transparent;
          border: solid 2px #c30000;
          z-index: 99;
          position: relative;

          .top {
            display: flex;
            height: 460px;

            .box1 {
              flex: 1;

              .topTitle {
                .p1 {
                  margin-top: 35px;
                }

                .p3 {
                  margin-bottom: 50px;
                }

                .p4,
                .p5 {
                  font-size: 16px;
                  line-height: 28px;
                  color: #545454;
                  text-indent: 2em;
                  padding-right: 10px;
                  font-weight: 400;
                }
              }
            }

            .box2 {
              width: 569px;
              height: 355px;
              position: relative;

              .imgBox {
                width: 622px;
                height: 408px;
                background-color: #ffffff;
                box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
                position: absolute;
                top: -53px;
                right: -53px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

            }
          }


        }
      }
    }

    .section3 {
      width: 100%;
      height: 841px;
      background-color: #fbfbfb;
      margin-top: -190px;

      .s3_innerBox {
        height: 100%;
        padding-top: 222px;

        .bodyBox {
          width: 100%;
          height: 540px;
          display: flex;

          .box1 {
            width: 807px;
            height: 100%;
            padding-left: 45px;
            display: flex;
            justify-content: space-between;

            .item {
              width: 247px;
              height: 540px;
              background-repeat: no-repeat;
              background-position: top center;
              position: relative;

              .label {
                position: absolute;
                left: 0;
                bottom: 0;
                font-size: 24px;
                color: #ffffff;
                font-weight: 700;
                width: 100%;
                height: 70px;
                line-height: 70px;
                text-align: center;
                background-color: rgba(195, 0, 0, 0.8);
              }
            }
          }

          .box2 {
            flex: 1;
            text-align: left;
            margin-left: 21px;

            .topTitle {
              .p1 {
                margin-top: 35px;
              }

              .p3 {
                margin-bottom: 56px;
              }

              .p4,
              .p5 {
                font-size: 16px;
                line-height: 28px;
                color: #545454;
                //   text-indent: 2em;
                padding-right: 10px;
                font-weight: 400;
              }
            }
          }


        }
      }
    }

    .section4 {
      width: 100%;
      height: 906px;
      background: url('../../static/images/metallurgy/应用领域.jpg') no-repeat;
      background-position: center;
      margin-top: 163px;
      margin-bottom: 180px;

      .s4_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 130px;
          }

          .p4 {
            font-size: 16px;
            line-height: 16px;
            color: #545454;
            font-weight: 400;
            margin-top: 49px;
          }
        }

        .bodyBox {
          margin-top: 110px;
          width: 100%;
          height: 420px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .p1 {
            width: 280px;
            height: 88px;
            line-height: 88px;
            background-color: rgba(195, 0, 0, 0.2);
            font-size: 18px;
            font-weight: 400;
            color: #545454;
          }

          .p1:hover {
            background-color: #c30000;
            color: #ffffff;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/metallurgy.vue